import {
  LINUX_OSS, APPLE_OSS, IE_BROWSERS, FF_BROWSERS,
  WINDOWS_OSS, ANDROID_OSS, EDGE_BROWSERS, OPERA_BROWSERS, SAFARI_BROWSERS, CHROME_BROWSERS
} from '../UserAgentParser/definitions'

export const ACCEPTED_OSS = [
  ...ANDROID_OSS,
  ...APPLE_OSS,
  ...WINDOWS_OSS,
  ...LINUX_OSS
] as const

export type TValidOs = 'Android' | 'iOS' | 'Mac OS' | 'Windows' | 'Linux'

export type TOs = TValidOs | undefined

export type TBaseVersion = string | undefined

export type TOsVersion = TBaseVersion

export interface IOsInfo {
  readonly name: TOs
  readonly version: TOsVersion
}

export const ACCEPTED_BROWSERS = [
  ...CHROME_BROWSERS,
  ...FF_BROWSERS,
  ...EDGE_BROWSERS,
  ...IE_BROWSERS,
  ...OPERA_BROWSERS,
  ...SAFARI_BROWSERS
] as const

export type TValidBrowser = 'Chrome' | 'Firefox' | 'Edge' | 'IE' | 'Opera' | 'Safari'

export type TBrowser = TValidBrowser | undefined

export type TBrowserVersion = TBaseVersion

export interface IBrowserInfo {
  readonly name: TBrowser
  readonly version: TBrowserVersion
}

const DEVICES = [ 'Android', 'Handheld', 'iOS', 'iPad', 'Tablet', 'Mobile', 'PC' ] as const

export type TDevice = typeof DEVICES[number]

export {
  LINUX_OSS, APPLE_OSS, WINDOWS_OSS,
  ANDROID_OSS, IE_BROWSERS, FF_BROWSERS,
  EDGE_BROWSERS, OPERA_BROWSERS, SAFARI_BROWSERS,
  CHROME_BROWSERS
}

export { IOS_OSS, MAC_OS_OSS } from '../UserAgentParser/definitions'
